import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1046"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M1.586 12.321c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.066 6.312.123a.7.7 0 1 0 .689-1.219c-.123-.069-3.069-1.692-7.444-.232-2.021.677-5.34.119-5.373.113a.71.71 0 0 0-.808.572.7.7 0 0 0 .572.808zm13.054 1.182c-.123-.069-3.069-1.692-7.444-.232-2.02.676-5.34.119-5.373.113a.708.708 0 0 0-.808.572.7.7 0 0 0 .571.808c.091.016 1.427.24 2.99.24 1.019 0 2.134-.095 3.062-.405 3.753-1.253 6.211.067 6.312.123a.698.698 0 0 0 .954-.265.699.699 0 0 0-.264-.954zM2.714 9.419h10.581a.591.591 0 0 0 .478-.94l-5.29-7.253a.592.592 0 0 0-.956 0l-5.29 7.253a.591.591 0 0 0 .477.94zM8.005 7.68a.433.433 0 1 1 0-.866.433.433 0 0 1 0 .866zm0-3.585c.327 0 .578.289.533.612l-.24 1.713h-.587l-.239-1.712a.538.538 0 0 1 .533-.613z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }